@if (userWorkspaceService.mailAccounts.length) {
  <div class="flex flex-wrap justify-between gap-y-2">
    <div class="flex w-full items-center gap-1 tablet:w-auto">
      <button
        tourAnchor="create-button"
        class="h-[40px] !min-w-fit text-nowrap"
        mat-raised-button
        color="primary"
        (click)="!userWorkspaceService.isChangeAccount && createEmail()"
        matTooltip="{{ 'createEmail' | translate }}"
        [disabled]="emailsPageStateService.isError">
        <mat-icon class="mr-2 min-w-[24px]">mail_outline</mat-icon>
        <span class="hidden md:inline">
          {{ 'newEmail' | translate }}
        </span>
        <span class="md:hidden">
          {{ 'newEmailMobile' | translate }}
        </span>
      </button>

      @if (!emailsPageStateService.isMailFolderTypeOutbox()) {
        @if (isExporting) {
          <div class="w-[2.5rem]">
            <app-loader
              padding="0"
              [diameter]="'22'"
              height="100%"></app-loader>
          </div>
        } @else {
          <button
            tourAnchor="export-button"
            [disabled]="emailsPageStateService.isError"
            mat-icon-button
            [attr.aria-label]="'exportExcel' | translate"
            (click)="!userWorkspaceService.isChangeAccount && exportExcel()"
            matTooltip="{{ 'exportExcelLabel' | translate }}">
            <i class="far fa-file-excel fa-xs"></i>
          </button>
        }
      }

      @if (emailsPageStateService.isImportEML()) {
        <button
          [disabled]="emailsPageStateService.isError"
          mat-icon-button
          [attr.aria-label]="'importEML' | translate"
          (click)="!userWorkspaceService.isChangeAccount && importEML()"
          matTooltip="{{ 'importEML' | translate }}">
          <i class="fa-solid fa-upload fa-xs"></i>
        </button>
      }

      <div class="icon-button-group flex items-center justify-between">
        @if (!emailsPageStateService.selection.isEmpty()) {
          <app-emails-header-action-buttons class="hidden 2xl:flex" />
          <app-emails-header-action-buttons-mobile class="flex 2xl:hidden" />
        }
      </div>
    </div>

    @if (!emailsPageStateService.isError) {
      <div
        class="mt-2 flex w-full flex-wrap-reverse items-center justify-between md:ml-auto md:mt-0 md:w-auto md:justify-end">
        <div class="flex w-full flex-wrap items-center justify-end md:hidden">
          <div class="flex w-full items-center justify-between">
            <div>
              <app-email-all-select-checkbox />
            </div>
            <ng-container
              *ngTemplateOutlet="
                tableHeader;
                context: { mobile: true }
              "></ng-container>
          </div>
        </div>
        <div class="ml-auto hidden flex-wrap items-center justify-end md:flex">
          <mat-slide-toggle
            [checked]="emailsPageStateService.searchParams.seen === false"
            (change)="showOnlyUnseen(!$event.checked)"
            class="mr-3"
            color="primary"
            matTooltip="{{ 'onlyUnseen' | translate }}"></mat-slide-toggle>
          <ng-container
            *ngTemplateOutlet="
              tableHeader;
              context: { mobile: false }
            "></ng-container>
        </div>
      </div>
    }
  </div>

  @if (emailsPageStateService.isError) {
    <app-something-went-wrong
      class="h-[80%]"
      description="{{ 'cannotLoadEmails' | translate }}"
      (retryEmitter)="emailsService.retryData()"
      [showPicture]="false"></app-something-went-wrong>
  }

  @if (emailsPageStateService.showLoader) {
    <div class="flex-1 overflow-hidden">
      <app-skeleton-table
        [countColumns]="
          emailsPageStateService.displayedColumns.length
        "></app-skeleton-table>
    </div>
  }

  @if (!emailsPageStateService.isError && !emailsPageStateService.showLoader) {
    @if (useMobileView) {
      <app-emails-mobile
        class="h-full md:hidden"
        (rightClick)="onRightClick($event.event, $event.email)" />
    } @else {
      <app-emails-desktop
        class="table-container hidden flex-1 md:block"
        tourAnchor="emails"
        (sortData)="sortData($event)"
        (rightClick)="onRightClick($event.event, $event.email)"
        (startRecording)="onStartRecording($event)"
        (finishRecording)="onFinishRecording($event.event, $event.email)" />
    }
  }

  <ng-template #metaDrawer>
    <app-email-meta
      [emailId]="emailsPageStateService.metaMailId"
      [title]="'meta'"></app-email-meta>
  </ng-template>

  <ng-template #notesDrawer>
    <app-email-note-list
      [emailId]="emailsPageStateService.notesMailId"
      [title]="'notes'"
      (refreshNotes)="refreshNotes()"></app-email-note-list>
  </ng-template>

  <ng-template #auditDrawer>
    <app-email-audit
      [title]="'audit'"
      [emailId]="emailsPageStateService.auditMailId"></app-email-audit>
  </ng-template>

  <ng-template #createOrUpdateDrawer>
    @if (emailsPageStateService.infoOpenedMailAccount.acc !== undefined) {
      <app-email-create-or-update
        [mailAccountId]="emailsPageStateService.infoOpenedMailAccount.acc"
        [emailId]="emailsPageStateService.updatedEmail?.emailId"
        [inlineImagesSourceEmailId]="
          emailsPageStateService.updatedEmail?.parentEmailId
        "
        [initialToRecipients]="
          emailsPageStateService.infoInitialContactsTo?.to ?? []
        "
        [useMobileView]="useMobileView"
        (submitted)="closeCreateOrUpdateModalForm()"
        (deleteFromData)="deleteFromData($event)"
        (refreshNotesDraft)="refreshNotes()"
        (changeDraftData)="changeDraftData($event)">
      </app-email-create-or-update>
    }
  </ng-template>

  <ng-template #emailDrawer>
    @if (
      emailsPageStateService.openedEmail &&
      emailsPageStateService.openedEmail?.emailId &&
      emailsPageStateService.infoOpenedMailAccount &&
      emailsPageStateService.infoOpenedMailAccount.acc !== undefined &&
      emailsPageStateService.infoOpenedMailAccount.type !== undefined &&
      emailsPageStateService.infoOpenedMailAccount.folder !== undefined
    ) {
      <app-email-detail-dialog
        [mailFolderId]="emailsPageStateService.infoOpenedMailAccount.folder"
        [currentFolderType]="emailsPageStateService.infoOpenedMailAccount.type"
        [emailId]="emailsPageStateService.openedEmail.emailId"
        (closeDrawer)="closeEmailModalForm($event)"
        [useMobileView]="useMobileView"
        (getInfoAboutOpenedEmail)="getInfoAboutOpenedEmail($event)"
        (setSeenOpened)="setSeenOpened($event)"
        [notesCount]="emailsPageStateService.openedEmail.notesCount"
        (refreshNotes)="refreshNotes()"
        (deleteFromData)="deleteFromData($event)">
      </app-email-detail-dialog>
    }
  </ng-template>

  <ng-template #importEMLIsDrawer>
    @if (emailsPageStateService.infoOpenedMailAccount.acc !== undefined) {
      <app-import-eml
        (loading)="loadingImportEML($event)"
        [mailAccountId]="emailsPageStateService.infoOpenedMailAccount.acc"
        (closeDrawer)="emailsService.loadData(false, true)"></app-import-eml>
    }
  </ng-template>

  <ng-template #notificationDrawer>
    <app-email-notifications-dialog
      [title]="'notifications'"
      [emailId]="emailsPageStateService.notificationMailId"
      (openEmailDetails)="actionsModals.openEmailDetails($event)">
    </app-email-notifications-dialog>
  </ng-template>
} @else {
  <div class="flex h-full items-center justify-center">
    <p class="m-[auto] text-center">
      {{ 'noMailAccountIsAvailableYet' | translate }}
    </p>
  </div>
}

<div
  style="visibility: hidden; position: fixed"
  [style.left]="menuTopLeftPosition.x"
  [style.top]="menuTopLeftPosition.y"
  [matMenuTriggerFor]="mailMenu"></div>

<mat-menu #mailMenu="matMenu" class="menu">
  <ng-template matMenuContent let-item="item">
    <app-email-action-buttons [email]="item" [isMenu]="true" />
  </ng-template>
</mat-menu>

<ng-template #tableHeader let-mobile="mobile">
  <app-table-header
    [countTotal]="countTotal"
    [selectedCount]="emailsService.selectedCount"
    (reloadEventEmitter)="emailsService.reload()"
    [searchOrder]="mobile ? emailsPageStateService.searchOrder : undefined"
    [searchOrders]="mobile ? emailsPageStateService.searchOrders : []"
    (searchOrderChangeEventEmitter)="
      mobile ? searchOrderChange($event) : undefined
    "
    [isReloadLoading]="
      emailsPageStateService.isReloadLoading
    "></app-table-header>
</ng-template>

<ng-template #addTagDrawer>
  @if (!!emailsPageStateService.emailsForTags) {
    <app-email-add-tags-dialog
      (closeEventEmitter)="onCloseEditModalForm()"
      (submitEventEmitter)="onCreateTag($event)"
      [emailsForTags]="
        emailsPageStateService.emailsForTags
      "></app-email-add-tags-dialog>
  }
</ng-template>

<ng-template #addGroupDrawer>
  @if (
    !!emailsPageStateService.infoOpenedMailAccount.acc &&
    emailsPageStateService.emailIdsForGroup
  ) {
    <app-email-add-groups-dialog
      [emailIds]="emailsPageStateService.emailIdsForGroup"
      [mailAccountId]="emailsPageStateService.infoOpenedMailAccount.acc"
      (closeEventEmitter)="onCloseGroupModalForm()"
      (submitEventEmitter)="onAddGroup($event)"></app-email-add-groups-dialog>
  }
</ng-template>
